import { PageLayout, TertiaryBar } from '@kcftech/design-system';
import { ICorporationResponse, ILocationResponse } from '@kcftech/prometheus-client';
import { DocumentTitle } from 'components/DocumentTitle';
import { NavTabLink } from 'components/tabs/NavTabs';
import { TabRouter } from 'components/tabs/TabRouter';
import { useRouteTabs } from 'custom_hooks/data_hooks/data_source/useRouteTabs';
import { ContentTabConfig } from 'custom_hooks/data_hooks/data_source/useTabs';
import { AnalyticsModelsTable } from 'pages/Models/AnalyticsModelTab/AnalyticsModelsTable';
import { AssignedModelTab } from 'pages/Models/AssignedModalTab/AssignedModelTab';
import { useMemo } from 'react';
import {
    getBaseModelRoute,
    getCorporationModelRoute,
    getLocationModelRoute,
} from 'utils/RouteHelper';

export const getTabRouteFromNavType = (
    corporationId: string | undefined,
    locationId: string | undefined,
    tab: string,
    modelId?: string,
) => {
    if (locationId) {
        return `${getLocationModelRoute(locationId, tab, modelId)}`;
    }
    if (corporationId) {
        return `${getCorporationModelRoute(corporationId, tab, modelId)}`;
    }
    return getBaseModelRoute(tab, modelId);
};

export type AnalyticsModelsTabsProps = Readonly<{
    corporation?: ICorporationResponse;
    location?: ILocationResponse;
}>;

export function AnalyticsModelsTabs({ location, corporation }: AnalyticsModelsTabsProps) {
    const { routeTabs, currentTab } = useRouteTabs(
        useMemo<ContentTabConfig[]>(
            () => [
                {
                    id: 'repository',
                    label: 'Model Repository',
                    content: (
                        <AnalyticsModelsTable
                            corporation={corporation}
                            location={location}
                        />
                    ),
                },
                {
                    id: 'assigned',
                    label: 'Model Assignments',
                    content: (
                        <AssignedModelTab location={location} corporation={corporation} />
                    ),
                },
            ],
            [corporation, location],
        ),
    );
    return (
        <>
            <PageLayout.Tertiary className="scrollable-x">
                <TertiaryBar.Navigation className="mb-0">
                    <TertiaryBar.Items>
                        <TertiaryBar.Item>
                            <DocumentTitle
                                title={`${
                                    location?.Name ?? corporation?.Name ?? ''
                                } Analytics Model ${
                                    currentTab?.id === 'repository'
                                        ? 'Settings'
                                        : 'Assignments'
                                }`}
                            />
                            {routeTabs.map(({ id, url, label }) => (
                                <NavTabLink key={id} to={url} className="p-10">
                                    {label}
                                </NavTabLink>
                            ))}
                        </TertiaryBar.Item>
                    </TertiaryBar.Items>
                </TertiaryBar.Navigation>
            </PageLayout.Tertiary>
            <TabRouter routeTabs={routeTabs} />
        </>
    );
}
